import type { Lockable } from "./support";
import type { Tier } from "./tier";
import type { CollectionTrack } from "./track";

export type CollectionServiceStatus =
  | "Incomplete"
  | "InUse"
  | "Ready"
  | "Ineligible";

export type CollectionServiceDetails = {
  ids: Array<string> | null;
  status: CollectionServiceStatus;
};

export type CollectionService = {
  fanzone: CollectionServiceDetails;
  distribution: CollectionServiceDetails;
};

export type CollectionBase = {
  artistUid: string;
  createdAt: string;
  uid: string;
};

export type CollectionInfo = {
  coverPath: Lockable<string>;
  description: Lockable<string>;
  title: Lockable<string>;
};

export type CollectionInfoWithEntries = CollectionInfo & {
  entries: Lockable<Array<CollectionEntry>>;
};

export type CollectionInList = CollectionBase & {
  entryCount: number;
  info: {
    coverPath: string | null;
    description: string | null;
    title: string;
  };
  isDeletable: boolean;
  services: CollectionService;
};

export type CollectionEntry = {
  audioUid: string;
  copyrightInfringement: boolean;
  title: string | null;
};

export type CollectionDetails = CollectionBase & {
  durationInSeconds: number | null;
  info: CollectionInfoWithEntries;
};

export type CollectionInFanzone = CollectionBase & {
  coverPath: string | null;
  description: string | null;
  name: string;
  tiers: Array<Tier>;
  tracks: Array<CollectionTrack>;
};

export type CollectionEditableFields = Pick<CollectionBase, "uid"> & {
  info: CollectionInfo;
};

export function isCollectionEditable(collection: CollectionEditableFields) {
  return [
    collection.info.coverPath,
    collection.info.description,
    collection.info.title,
  ].some((field) => !field.isLocked);
}
